import { useContext } from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import AnalyticsPostCampaignReportListViewProfile from '@components/Analytics/PostCampaignReport/ListView/Profile/Profile'
import { getBackgroundColor } from '@components/Analytics/PostCampaignReport/Post/List/List'
import { CampaignContext } from '@context/Campaign'
import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { isSupportedPCRMetricsChannel, selectSnapMetricIds } from '@store/postCampaignReport'
import { selectPcrMetricIds } from '@store/postCampaignReport/metrics/selectors'
import { Container } from '@tribegroup'
import AnalyticsPostCampaignReportListView from '../ListView/ListView'
import { AnalyticsPostCampaignReportSubmissionListHeaders } from './ListHeaders'
import { AnalyticsPostCampaignReportSubmissionListItem } from './ListItem'

type Props = {
  activeChannel: PCRChannels
}

export const AnalyticsPostCampaignReportSubmissionList: React.FC<Props> = ({ activeChannel }) => {
  const {
    campaign: { id: campaignId },
  } = useContext(CampaignContext)

  const { submissionIds } = useSelector((state: IApplicationState) => {
    if (isSupportedPCRMetricsChannel(activeChannel)) {
      return {
        submissionIds: selectPcrMetricIds(state, activeChannel, campaignId),
      }
    }
    return {
      submissionIds: selectSnapMetricIds(state, campaignId),
    }
  }, shallowEqual)

  const profiles = submissionIds.map((submissionId, index) => (
    <Container data-testid="x-profile-wrapper" key={`profile-${submissionId}`}>
      <AnalyticsPostCampaignReportListViewProfile
        backgroundColor={getBackgroundColor(index)}
        submissionId={submissionId}
      />
    </Container>
  ))

  return (
    <AnalyticsPostCampaignReportListView
      profiles={profiles}
      headers={<AnalyticsPostCampaignReportSubmissionListHeaders />}
    >
      <>
        {submissionIds.map((submissionId, index) => (
          <Container key={`x-list-${submissionId}`} data-testid="x-list-item">
            <AnalyticsPostCampaignReportSubmissionListItem
              submissionId={submissionId}
              backgroundColor={getBackgroundColor(index)}
              activeChannel={activeChannel}
            />
          </Container>
        ))}
      </>
    </AnalyticsPostCampaignReportListView>
  )
}
